import React, { useEffect, useState } from "react";
import { isMobile } from "../App";
import { ApiService } from "../services/http.service";
import {
  dateForRequest,
  formatTrainerName,
  getTrainingDistances,
  loadingAnimation,
  useForceUpdate,
} from "../services/misc.functions";

import { TrainingCells } from "../components/shared/graph/training_cells";
import { GraphCircles } from "../components/shared/graph/graph_circles";
import WayType from "../components/shared/way_type/way_type";
import TrainingPower from "../components/shared/training_power/training_power";

import ArrowUp from "../assets/icons/up-arrow.svg";
import ArrowDown from "../assets/icons/down-arrow.svg";

import { formatDate } from "date-fns";
import {
  results,
  shownRun,
  shownRunSubject,
  statisticsOptions,
  statisticsOptionsSubject,
} from "../stores/statistics.store";
import _ from "lodash";

export const Galops: React.FC<any> = () => {
  const [runData, setRunData] = useState<any>(null);
  const [visibleRunners, setVisibleRunners] = useState<{ [key: string]: boolean }>({});
  const [loading, setLoading] = useState<boolean>(true);

  const api = new ApiService();
  const forceUpdate = useForceUpdate();

  const fetchData = (date: Date) => {
    setLoading(true);

    api
      .start("post", "https://tjk-statistics.bitrelic.io/api/trainings/", {
        date: dateForRequest(date),
      })
      .then((response: any) => {
        if (response && response.data) {
          results.length = 0;
          results.push(...response.data);

          setRunData(
            response.data.find(
              (item: any) => item.hippodrome_key === shownRun.hippodrome_key && item.run_no === shownRun.run_no
            )
          );

          setLoading(false);
          forceUpdate();
        }
      });
  };

  useEffect(() => {
    fetchData(statisticsOptions.date);

    statisticsOptionsSubject.subscribe(() => {
      fetchData(statisticsOptions.date);
      forceUpdate();
    });

    shownRunSubject.subscribe(() => {
      setRunData(
        results.find((item: any) => item.hippodrome_key === shownRun.hippodrome_key && item.run_no === shownRun.run_no)
      );
      forceUpdate();
    });
  }, []);

  const toggleRunnersVisibility = (horseName: string) => {
    setVisibleRunners((prev) => ({
      ...prev,
      [horseName]: !prev[horseName],
    }));
  };

  if (loading || !runData) {
    return (
      <div className="text-center">
        <div id="id_loaderAnimation" className="loader"></div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      {!isMobile && (
        <table className="table statistics-table table-borderless">
          <thead>
            <tr>
              <th className="text-center">#</th>
              <th className="text-start">Atın İsmi</th>
              <th className="text-start">Jokey</th>
              <th className="text-start">KG</th>
              <th className="row mx-0 flex-nowrap">
                {getTrainingDistances(runData?.runners_data?.map((runner: any) => runner.trainings).flat())?.map(
                  (dist, idx) => (
                    <div key={`galop-training-distance-${idx}`} className="col px-0 d-flex justify-content-center">
                      {dist}
                    </div>
                  )
                )}
              </th>
              <th className="text-center">Tarih</th>
              <th className="text-center">Şehir</th>
              <th className="text-center">Çaba</th>
              <th className="text-center">Pist</th>
              <th className="text-center"></th>
            </tr>
          </thead>

          <tbody>
            {runData
              ? _.sortBy(runData.runners_data, "horse_no").map((runner: any, keyHorse: number) => {
                  const { trainings } = runner;

                  const hasGalopTraining =
                    trainings.length > 0 && trainings.some((training: any) => training.training_type === "Galop");
                  // const previousRunner = keyHorse > 0 ? runData.runners_data[keyHorse - 1] : null;
                  // const isFirstRunner = !previousRunner || previousRunner.horse_name !== runner.horse_name;
                  const isVisible = visibleRunners[runner.horse_name] || false;
                  const distances = runData
                    ? getTrainingDistances(runData.runners_data.map((runner: any) => runner.trainings).flat())
                    : [];

                  return (
                    <React.Fragment key={`DataTable-horses-${keyHorse}`}>
                      <tr
                        className={`first-runner-${keyHorse % 2 === 0 ? "odd" : "even"}`}
                        onClick={() => (hasGalopTraining ? toggleRunnersVisibility(runner.horse_name) : null)}
                        style={{ cursor: "pointer", background: isVisible ? "#D7D9F7 " : "" }}
                      >
                        <td>
                          <div className="add-to-betslip">{runner.horse_no || "-"}</div>
                        </td>
                        <td className="text-start">
                          <span className="d-block fw-bold nowrap-ellipsis tooltip">{runner.horse_name || "-"}</span>
                        </td>
                        <td className="text-start">
                          {formatTrainerName(trainings[0]?.trainer_name) || "-"}{" "}
                          {trainings[0]?.training_type === "Sprint" && (
                            <span className="text-danger fs-7 fw-bold"> / Sprint</span>
                          )}
                        </td>
                        <td className="text-start">{trainings[0]?.trainer_weight || "-"}</td>
                        <td className="graph-container">
                          <div className="row mx-0 flex-nowrap">
                            <TrainingCells trainings={trainings} distances={distances} />
                          </div>
                          <div className="row mx-0 flex-nowrap graph-position-relative">
                            <div className="graph-line"></div>
                            <GraphCircles trainings={trainings} distances={distances} />
                          </div>
                        </td>
                        <td className="text-center">
                          {trainings[0]?.training_date
                            ? formatDate(new Date(trainings[0]?.training_date), "dd.MM.yyyy")
                            : "-"}
                        </td>
                        <td className="text-center">{trainings[0]?.training_hippodrome || "-"}</td>
                        <td className="text-center">
                          <TrainingPower training_power={trainings[0]?.training_power} />
                        </td>
                        <td className="text-center">
                          <WayType type={trainings[0]?.training_way_type} />
                        </td>
                        <td>
                          {hasGalopTraining ? (
                            isVisible ? (
                              <img src={ArrowUp} alt="arrow-up" />
                            ) : (
                              <img src={ArrowDown} alt="arrow-down" />
                            )
                          ) : null}
                        </td>
                      </tr>

                      {trainings.map((training: any, trainingKey: number) => {
                        if (trainingKey !== 0) {
                          return (
                            <tr
                              key={`Tjk-races-${keyHorse}-${trainingKey}`}
                              className={`secondary-runner ${isVisible ? "show" : "hide"}`}
                            >
                              <td></td>
                              <td>
                                <span className="d-block fw-bold nowrap-ellipsis tooltip"></span>
                              </td>
                              <td className="text-start">
                                {formatTrainerName(training.trainer_name) || "-"}{" "}
                                {training.training_type === "Sprint" && (
                                  <span className="text-danger fs-7 fw-bold"> / Sprint</span>
                                )}
                              </td>

                              <td className="text-start">{training?.trainer_weight || "-"}</td>

                              <td className="graph-container">
                                <div className="row mx-0 flex-nowrap">
                                  <TrainingCells trainings={[training]} distances={distances} />
                                </div>
                                <div className="row mx-0 flex-nowrap graph-position-relative">
                                  <div className="graph-line"></div>
                                  <GraphCircles trainings={[training]} distances={distances} />
                                </div>
                              </td>
                              <td className="text-center">
                                {formatDate(new Date(training.training_date), "dd.MM.yyyy") || "-"}
                              </td>
                              <td className="text-center">{training.training_hippodrome || "-"}</td>
                              <td className="text-center">
                                <TrainingPower training_power={training.training_power} />
                              </td>
                              <td className="text-center">
                                <WayType type={training.training_way_type} />
                              </td>
                              <td></td>
                            </tr>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </React.Fragment>
                  );
                })
              : null}
          </tbody>
        </table>
      )}

      {isMobile && runData
        ? _.sortBy(runData.runners_data, "horse_no").map((runner: any, keyHorse: number) => {
            const { trainings } = runner;
            const hasGalopTraining =
              trainings.length > 0 && trainings.some((training: any) => training.training_type === "Galop");
            // const previousRunner = keyHorse > 0 ? runData.runners_data[keyHorse - 1] : null;
            // const isFirstRunner = !previousRunner || previousRunner.horse_name !== runner.horse_name;
            const isVisible = visibleRunners[runner.horse_name] || false;

            const distances = runData
              ? getTrainingDistances(runData.runners_data.map((runner: any) => runner.trainings).flat())
              : [];

            return (
              <div className="mobile-statistics-table" key={`DataTable-horse-${keyHorse}`}>
                <div
                  onClick={() => (hasGalopTraining ? toggleRunnersVisibility(runner.horse_name) : null)}
                  style={{ cursor: "pointer", background: isVisible ? "#D7D9F7" : "" }}
                >
                  <div className="horse-no" style={{ cursor: "pointer", background: isVisible ? "#D7D9F7" : "" }}>
                    {runner.horse_no || "-"}
                  </div>
                  <div className="horse-result nowrap-ellipsis row">
                    <div className="horse-info col-3">
                      <span className="horse-name text-truncate">{runner.horse_name || "-"} </span>
                      <TrainingPower training_power={trainings[0]?.training_power} />
                    </div>
                    <div className="col-9 run-info">
                      <div className={"d-flex justify-content-between"}>
                        <div className={"d-flex"}>
                          <span className={`d-block`}>{formatTrainerName(trainings[0]?.trainer_name)}</span>
                          <span className="d-block"> &nbsp;{trainings[0]?.trainer_weight || " - "}kg</span>
                        </div>
                        <div className={"d-flex"}>
                          <span className={`d-block`}>
                            {trainings[0]?.training_date
                              ? formatDate(new Date(trainings[0]?.training_date), "dd.MM.yyyy")
                              : "-"}
                          </span>
                        </div>
                        <div className={"d-flex"}>
                          <span className={`d-block`}>{trainings[0]?.training_hippodrome}</span>
                        </div>
                        <div className={"d-flex"}>
                          <WayType type={trainings[0]?.training_way_type} />
                        </div>
                      </div>
                      <div className="graph-container mt-2">
                        <div className="row mx-0 flex-nowrap">
                          <TrainingCells trainings={trainings} distances={distances} />
                        </div>
                        <div className="row mx-0 flex-nowrap graph-position-relative">
                          <div className="graph-line"></div>
                          <GraphCircles trainings={trainings} distances={distances} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horse-detail-opener active">
                    {hasGalopTraining ? (
                      isVisible ? (
                        <img src={ArrowUp} alt="arrow-up" />
                      ) : (
                        <img src={ArrowDown} alt="arrow-down" />
                      )
                    ) : null}
                  </div>
                </div>

                {trainings.map((training: any, trainingKey: number) => {
                  if (trainingKey !== 0) {
                    return (
                      <div
                        key={`DataTable-trains-${keyHorse}-${trainingKey}`}
                        style={{ cursor: "pointer", backgroundColor: "#E1E3F7" }}
                        className={isVisible ? "show" : "hide"}
                      >
                        <div
                          className="horse-no"
                          style={{ cursor: "pointer", backgroundColor: isVisible ? "#E1E3F7" : "" }}
                        ></div>
                        <div className="horse-result nowrap-ellipsis row">
                          <div className="horse-info col-3">
                            <div className="d-flex m-2">
                              &nbsp;{" "}
                              <span className="d-block">
                                <TrainingPower training_power={training.training_power} />
                              </span>
                            </div>
                          </div>
                          <div className="col-9 run-info">
                            <div className="d-flex justify-content-between">
                              <div className="d-flex">
                                <span className="d-block">{formatTrainerName(training.trainer_name)}</span>
                                <span className="d-block"> &nbsp;{training.trainer_weight || " - "}kg</span>
                              </div>
                              <div className="d-flex">
                                &nbsp;{" "}
                                <span className="d-block">
                                  {formatDate(new Date(training.training_date), "dd.MM.yyyy") || "-"}
                                </span>
                              </div>
                              <div className="d-flex">
                                &nbsp; <span className="d-block">{training?.training_hippodrome}</span>
                              </div>
                              <div className="d-flex">
                                &nbsp; <WayType type={training?.training_way_type} />
                              </div>
                            </div>
                            <div className="graph-container mt-2">
                              <div className="row mx-0 flex-nowrap">
                                <TrainingCells trainings={[training]} distances={distances} />
                              </div>
                              <div className="row mx-0 flex-nowrap graph-position-relative">
                                <div className="graph-line"></div>
                                <GraphCircles trainings={[training]} distances={distances} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="horse-detail-opener"></div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            );
          })
        : null}

      <div className="info">
        <span className="title">Galoplar</span>
        <span className="description">
          Atların yarışa hazırlanmak için belirli aralıklarla yaptıkları idmanlardır. Bu idmanlar en kısa 400 metre, en
          uzun ise 1400 metredir.
        </span>
      </div>
    </div>
  );
};
